import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import { getSize, getColor } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Button, Tooltip } from 'antd';
import Image from 'next/image';
import { useMemo } from 'react';
import { AiChangeType } from '../../../../ai';
import { HeadingAiChangeStrategyFactory, HeadingDescriptionLabel } from './strategies';
import { getEditBadgeStyles } from '../../shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  ", "\n  border-radius: ", ";\n  padding: ", ";\n"])), function (props) {
  return getSize('padding20')(props);
}, function (_ref) {
  var $changeType = _ref.$changeType,
      theme = _ref.theme;

  var _getEditBadgeStyles = getEditBadgeStyles($changeType, theme),
      bg = _getEditBadgeStyles.bg,
      border = _getEditBadgeStyles.border;

  return "\n      background-color: ".concat(bg, ";\n      border: 2px dashed ").concat(border, ";\n    ");
}, function (props) {
  return getSize('radiusSm')(props);
}, function (props) {
  return getSize('padding24')(props);
});
var StyledTopBar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledTopLeft = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding8')(props);
});
var StyledEditBadge = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  font-size: ", ";\n  font-weight: 700;\n  border-radius: 9999px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n  border: 1px solid transparent;\n\n  ", "\n"])), function (props) {
  return getSize('typo14')(props);
}, function (_ref2) {
  var $changeType = _ref2.$changeType,
      theme = _ref2.theme;

  var _getEditBadgeStyles2 = getEditBadgeStyles($changeType, theme),
      badgeBgColor = _getEditBadgeStyles2.badgeBgColor,
      color = _getEditBadgeStyles2.color,
      border = _getEditBadgeStyles2.border;

  return "\n      background-color: ".concat(badgeBgColor, ";\n      color: ").concat(color, ";\n      border-color: ").concat(border, ";\n    ");
});
/** Tag style copied from card-title StyledTag (heading-v2-preview) – same look, no shared import */

var StyledHeadingType = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background: #dbeafe;\n  border-radius: ", ";\n  margin-right: ", ";\n  font-weight: 700;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n"])), getSize('padding4'), getSize('padding12'), getSize('typo14'), getSize('typo24'), getColor('fillIntActive'), getSize('radiusS'), getSize('padding16'));
/** Layout copied from section-ai-change-preview – tag + title in one row below top bar */

var HeadingTitleWithTagContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  overflow: visible;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n"])));
var HeadingTitleArea = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  overflow: visible;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n"])));
var HeadingTitleDisplay = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ", ";\n  padding: ", ";\n  border: none;\n  width: 100%;\n  line-height: ", ";\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  border-radius: unset;\n  overflow: hidden;\n  background: transparent;\n  color: inherit;\n"])), getSize('typo24'), getSize('padding0'), getSize('typo32'));
var StyledTopActions = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (props) {
  return getSize('padding12')(props);
});
var StyledMentionButton = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #cbd5e1;\n    background: #f8fafc;\n  }\n"])));
var StyledRejectButton = styled(Button)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  color: #1e293b;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: white;\n\n  &:hover {\n    color: #1e293b !important;\n    border-color: #cbd5e1 !important;\n    background: #f8fafc !important;\n  }\n\n  svg {\n    font-size: 16px;\n  }\n"])));
/** Match base-question-ai-change-preview Accept button (blue, checkmark) */

var StyledAcceptButton = styled(Button)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 8px;\n  background-color: #2563eb !important;\n  border-color: #2563eb !important;\n  color: #ffffff !important;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  &:hover {\n    background-color: #1e40af !important;\n    border-color: #1e40af !important;\n  }\n\n  svg {\n    font-size: 16px;\n  }\n"])));
var StyledDescriptionBlock = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n"])), function (props) {
  return props.$isUpdate ? getSize('padding8')(props) : 0;
});
export var HeadingAiChangePreviewComponent = function HeadingAiChangePreviewComponent(_ref3) {
  var states = _ref3.states,
      actions = _ref3.actions,
      strategyProp = _ref3.strategy,
      id = _ref3.id;
  var labels = states.labels,
      before = states.before,
      after = states.after,
      changeType = states.changeType,
      isAccepting = states.isAccepting;
  var onAccept = actions.onAccept,
      onReject = actions.onReject,
      onMention = actions.onMention;
  var strategy = useMemo(function () {
    return strategyProp !== null && strategyProp !== void 0 ? strategyProp : HeadingAiChangeStrategyFactory.create({
      changeType: changeType,
      before: before,
      after: after
    });
  }, [strategyProp, changeType, before, after]);
  return /*#__PURE__*/_jsxs(StyledCard, {
    $changeType: changeType,
    id: id,
    children: [/*#__PURE__*/_jsxs(HeadingTitleWithTagContainer, {
      children: [/*#__PURE__*/_jsx(StyledHeadingType, {
        children: "HEADING"
      }), /*#__PURE__*/_jsx(HeadingTitleArea, {
        children: /*#__PURE__*/_jsx(HeadingTitleDisplay, {
          children: strategy.renderTitle && strategy.renderTitle()
        })
      }), onMention && /*#__PURE__*/_jsx(Tooltip, {
        title: "Mention",
        placement: "bottom",
        children: /*#__PURE__*/_jsx(StyledMentionButton, {
          type: "button",
          onClick: function onClick(e) {
            e.stopPropagation();
            onMention();
          },
          children: /*#__PURE__*/_jsx(Image, {
            src: "/icons/ai.png",
            width: 16,
            height: 16,
            alt: "mention"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      children: [changeType === AiChangeType.Update && /*#__PURE__*/_jsx(HeadingDescriptionLabel, {
        children: labels.description
      }), /*#__PURE__*/_jsx(StyledDescriptionBlock, {
        $isUpdate: changeType === AiChangeType.Update,
        children: strategy.renderDescription()
      })]
    })]
  });
};